import React from 'react'
import cn from 'classnames'

import { useMarket } from 'src/hooks/useMarket'
import { usePage } from 'src/hooks/usePage'

export function WidgetPlaceholder() {
  const { pageId } = usePage()
  const { language, market } = useMarket()

  const classes = [`widget`, `page-${pageId}`, `lang-${language}`, `mkt-${market}`]

  return <div data-testid="widget-placeholder" className={cn(classes)} />
}
